const boardReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default boardReducer;